import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import './index.sass'

@Component
export class SwipeDot extends Vue {
  @Prop({ required: false, default: false })
  private active: boolean

  render (h: CreateElement) {
    return (
      <div class={`swipe-dot ${this.active ? 'active' : ''}`}>

      </div>
    )
  }
}
